var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{staticClass:"column-answer"},_vm._l((_vm.attrs.items),function(item,index){return _c(item.component,{key:index,tag:"component",attrs:{"formular":item,"context":_vm.context},on:{"update":function($event){return _vm.$emit('update')}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }